import React from 'react';
import { TooltipProps } from 'recharts';

import { Col, Cols, Div, fontSizing, Row, Rows, spacing, Text } from '~/src/dash/publicaUI';
import { addCommasToIntegerOrFloat } from '~/src/dash/utils/basic';
import { publicaColors } from '~/src/dash/utils/colors';

export const CustomTooltip = ({ active, payload, label }: TooltipProps) => {
  if (active && payload && payload.length) {
    return (
      <Div
        smallVerticalPadding
        horizontalPadding
        style={{
          backgroundColor: publicaColors.white,
          border: `1px solid ${publicaColors.lightGray}`,
        }}
      >
        <Rows gap={spacing.base} noVerticalPadding>
          <Row
            smallVerticalPadding
            noHorizontalPadding
            style={{
              borderBottom: `1px solid ${publicaColors.lightGray}`,
            }}
          >
            <Text small bold>
              {label}
            </Text>
          </Row>
          {payload.map((item) => {
            return (
              <Row noPadding>
                <Cols
                  gap={spacing.extraLarge}
                  style={{
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Col>
                    <Cols gap='4px' style={{ alignItems: 'center' }}>
                      <Col paddingBottom='1px'>
                        <Text color={item.fill} style={{ fontSize: fontSizing.small }}>
                          ⬤
                        </Text>
                      </Col>
                      <Col>
                        <Text small bold>
                          {item.name}
                        </Text>
                      </Col>
                    </Cols>
                  </Col>
                  <Col>
                    <Text small>
                      {item.dataKey === 'expectedImps'
                        ? addCommasToIntegerOrFloat(String(item.payload.expectedImps))
                        : addCommasToIntegerOrFloat(String(item.payload.bookedImps))}
                    </Text>
                  </Col>
                </Cols>
              </Row>
            );
          })}
        </Rows>
      </Div>
    );
  }

  return null;
};
